export default {
    id: 'cyan',
    colors: ['#1C666E', '#C2EEBA'],
};
